export const findLeastTime = (date: Date, intervalMs: number): Date => {
  return new Date(Math.round(+date / intervalMs) * intervalMs);
};

export const findLeastRightTime = (date: Date, intervalMs: number): Date => {
  return new Date(Math.ceil(+date / intervalMs) * intervalMs);
};
